{
  "label": "applicatif",
  "name": "Nom",
  "model": {
    "declination": "Gamme",
    "type": "Type"
  },
  "versionNumber": "Numéro de version",
  "serialNumber": "Numéro de série",
  "terminalName": "Nom du terminal",
  "windowsUserAccount": "Compte Windows de l'utilisateur",
  "sector": "Secteur",
  "connectivity": "Connectivité",
  "certificate": "Certificat",
  "state": "État",
  "states": {
    "activated": "Activé",
    "deactivated": "Désactivé",
    "registered": "Nouveau"
  },
  "actions": {
    "scheduled": {
      "title": "Actions en cours ?",
      "yes": "Oui",
      "no": "Non",
      "error": "Indéterminé"
    }
  },
  "additionalMetadata": {
    "title": "Métadonnées additionnelles",
    "username": "Nom d'utilisateur",
    "installationDate": "Date d'installation",
    "computerName": "Nom de l'ordinateur",
    "licenseId": "N° de licence : {value}",
    "options": {
      "title": "Options",
      "numericSoftware": {
        "1": "Postes locaux autorisés : {value}",
        "2": "Date d’expiration de la licence : {value}"
      }
    }
  },
  "firmwareVersion": "Version logicielle",
  "updateCertificate": "Mise à jour du certificat",
  "updateState": {
    "activate": {
      "title": "Activer",
      "execute": "Activer l'applicatif",
      "description": "L'applicatif {name} va être activé."
    },
    "deactivate": {
      "title": "Désactiver",
      "execute": "Désactiver l'applicatif",
      "description": "L'applicatif {name} va être désactivé.",
      "warning": "Un applicatif désactivé ne bénéficie plus des mises à jour manuelles et automatiques des certificats.",
      "error": "Cet applicatif ne peut pas être désactivé parce qu'il a une opération avec l'état en attente ou en cours."
    }
  },
  "month": "{n} mois | {n} mois",
  "year": "{n} an | {n} ans",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "empty": "Aucun applicatif n'a été trouvé.",
  "delete": {
    "execute": "Supprimer l'applicatif",
    "description": "L'applicatif {name} va être supprimé.",
    "warning": "Les opérations associées à l'applicatif seront également supprimées.",
    "error": "Cet applicatif ne peut pas être supprimé parce qu'il a une opération avec l'état en attente ou en cours."
  },
  "description": {
    "certificateValidityDate": "Date de validité du certificat",
    "communicationProtocol": "Protocole de communication",
    "configurationApplicationDate": "Date d'application de la configuration",
    "connectivity": "Connectivité",
    "firmwareVersion": "Version logicielle",
    "firstCommissioningDate": "Date de la première mise en service",
    "gsmFrequencyBand": "Bande de fréquence GSM",
    "idCard": "Carte d'identité",
    "lastChange": "Dernier changement",
    "lastConnection": "Dernière connexion",
    "lastFirmwareUpdate": "Dernière mise à jour du firmware",
    "lastRebootDate": "Date du dernier redémarrage",
    "mobileNetwork": "Réseau mobile",
    "model": "Gamme",
    "name": "Nom",
    "serialNumber": "Numéro de série",
    "state": "État",
    "terminalName": "Nom du terminal",
    "title": "Description",
    "type": "Type",
    "windowsUsername": "Compte Windows de l'utilisateur"
  },
  "certificateForm": {
    "expirationDate": "Date d'expiration du certificat",
    "certificateOrigin": "Origine du certificat",
    "lastUpdate": "Dernière mise à jour du certificat"
  },
  "operation": {
    "cancelAction": {
      "title": "Annuler l'opération",
      "confirm": {
        "title": "Êtes-vous sûr de vouloir annuler cette opération ?",
        "description": "Cette opération sera annulée"
      }
    },
    "updateAction": {
      "title": "Mettre à jour l'opération"
    },
    "unitary": "Unitaires",
    "campaign": "Campagnes"
  },
  "back": "retour"
}
